"use client"

import {useEffect, useState} from 'react';
import {gpxRequest} from "@/utils/api/Gpx";
import {Track} from "@we-gold/gpxjs";

const useLoadGpx = (gpx: string) => {
  const [data, setData] = useState<Track | undefined>(undefined)

  useEffect(() => {
    const fetchData = async () => {
      const fetched = await gpxRequest(gpx)
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data) {
      fetchData()
    }
  }, [data, gpx]);

  return data
};

export default useLoadGpx;
